import React, { useState, useEffect, useRef } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

import { Link, useLocation, useNavigate } from 'react-router-dom';


const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;


// const BoxWhiskerChart = () => {
//     const options = {
//         theme: "light2",
//         animationEnabled: true,
//         title: {
//             text: "Energy in Baked Foods"
//         },
//         axisY: {
//             title: "Energy Per 100 g (kcal/100g)"
//         },
//         // data: [{
//         //     type: "boxAndWhisker",
//         //     yValueFormatString: "#,##0.# \"kcal/100g\"",
//         //     dataPoints: [
//         //         { label: "Bread", y: [179, 256, 300, 418, 274] },
//         //         { label: "Cake", y: [252, 346, 409, 437, 374.5] },
//         //         { label: "Biscuit", y: [236, 281.5, 336.5, 428, 313] },
//         //         { label: "Doughnut", y: [340, 382, 430, 452, 417] },
//         //         { label: "Pancakes", y: [194, 224.5, 342, 384, 251] },
//         //         { label: "Bagels", y: [241, 255, 276.5, 294, 274.5] }
//         //     ]
//         // }]
//     };


// Function to generate random colors
function generateRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

const prepareDataset = (response, xAxisValues, rightListBoxWhiskerValue) => {
    console.log(JSON.stringify(rightListBoxWhiskerValue));
    const datasets = rightListBoxWhiskerValue.map((column, index) => {
        return {
            label: xAxisValues[index],
            data: response.map(item => item[column]),
            backgroundColor: generateRandomColor(), // You can define or generate colors here
        };
    });
    return datasets;
};

const BoxWhiskerChart = ({ selectedCombinedBoxWhiskerColumns, verticalBoxWhiskerLabel, horizantalBoxWhiskerLabel, boxWhiskerRightList,
    connectionNameValue, reportName }) => {
    console.log(JSON.stringify(selectedCombinedBoxWhiskerColumns) + "-" +
        JSON.stringify(verticalBoxWhiskerLabel) + "-" +
        JSON.stringify(horizantalBoxWhiskerLabel) + "-" +
        JSON.stringify(boxWhiskerRightList)
    );

    //const dataset = prepareDataset();
    const navigate = useNavigate();
    const location = useLocation();
    const [iframeUrl, setIframeUrl] = useState('');
    console.log(JSON.stringify(location.state) + "location.state--------------");

    let selectedCombinedBoxWhiskerColumnsValue = '';
    let verticalBoxWhiskerLabelValue = '';
    let horizantalBoxWhiskerLabelValue = '';
    let rightListBoxWhiskerValue = '';
    let connectionName = '';
    let reportNameValue = '';
    const [dataSets, setDataSets] = useState([]);
    const [xaxis, setXaxis] = useState([]);
    let datasets1;
    // Create an array to store the formatted datasets
    // const formattedDataPoints = [];



    if (location.state.selectedCombinedBoxWhiskerColumns !== undefined) {
        const { selectedCombinedBoxWhiskerColumns, verticalBoxWhiskerLabel, horizantalBoxWhiskerLabel,
            boxWhiskerRightList, connectionNameValue, reportName } = location.state;

        console.log(selectedCombinedBoxWhiskerColumns); // Output: "name"
        console.log(verticalBoxWhiskerLabel); // Output: "id"
        console.log(horizantalBoxWhiskerLabel); // Output: "Name Only"
        console.log(boxWhiskerRightList); // Output: "Name Only"

        selectedCombinedBoxWhiskerColumnsValue = location.state.selectedCombinedBoxWhiskerColumns;
        verticalBoxWhiskerLabelValue = location.state.verticalBoxWhiskerLabel;
        horizantalBoxWhiskerLabelValue = location.state.horizantalBoxWhiskerLabel;
        rightListBoxWhiskerValue = location.state.boxWhiskerRightList;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        console.log(JSON.stringify(selectedCombinedBoxWhiskerColumnsValue) + "selectedCombinedBoxWhiskerColumnsValueLOC"
            + JSON.stringify(verticalBoxWhiskerLabelValue) + "verticalBoxWhiskerLabelValueLOC"
            + JSON.stringify(horizantalBoxWhiskerLabelValue) + "horizantalBoxWhiskerLabelValueLOC"
            + JSON.stringify(rightListBoxWhiskerValue) + "rightListBoxWhiskerValueLOC");
    } else {

        selectedCombinedBoxWhiskerColumnsValue = selectedCombinedBoxWhiskerColumns;
        verticalBoxWhiskerLabelValue = verticalBoxWhiskerLabel
        horizantalBoxWhiskerLabelValue = horizantalBoxWhiskerLabel;
        rightListBoxWhiskerValue = boxWhiskerRightList;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        console.log(JSON.stringify(selectedCombinedBoxWhiskerColumnsValue) + "selectedCombinedBoxWhiskerColumnsValue");
        console.log(JSON.stringify(verticalBoxWhiskerLabelValue) + "verticalLabelBoxWhiskerValue");
        console.log(JSON.stringify(horizantalBoxWhiskerLabelValue) + "horizantalBoxWhiskerLabelValue");
        console.log(JSON.stringify(rightListBoxWhiskerValue) + "rightListBoxWhiskerValue"
            + JSON.stringify(selectedCombinedBoxWhiskerColumnsValue) + "selectedCombinedBoxWhiskerColumnsValue"
            + JSON.stringify(verticalBoxWhiskerLabelValue) + "verticalBoxWhiskerLabelValue"
            + JSON.stringify(horizantalBoxWhiskerLabelValue) + "horizantalBoxWhiskerLabelValue");
    }


    const handleClick = () => {
        console.log('Bar chart clicked!');

        navigate('/barChart', { state: { selectedCombinedBoxWhiskerColumns, verticalBoxWhiskerLabel, horizantalBoxWhiskerLabel, boxWhiskerRightList, connectionName, reportNameValue } });
    };

    console.log(JSON.stringify(selectedCombinedBoxWhiskerColumnsValue) + "selectedCombinedBarColumns");
    console.log(JSON.stringify(verticalBoxWhiskerLabelValue) + "verticalLabel");
    console.log(JSON.stringify(horizantalBoxWhiskerLabelValue) + "horizantalLabel");
    console.log(JSON.stringify(rightListBoxWhiskerValue) + "rightList");

    const [data, setData] = useState({
        labels: [],
        datasets: [],
    });
    useEffect(() => {
        const fetchData = async () => {
            const url = 'product.json'
            //const url = 'https://dummyjson.com/products'
            //const url ='https://dummy.restapiexample.com/api/v1/employees'
            // const url = 'https://jsonplaceholder.typicode.com/users'
            //const url ='https://jsonplaceholder.typicode.com/comments'

            await fetch(url).then((data) => {
                console.log("Api data", data)
                const response = data.json();
                return response
            }).then((response) => {
                console.log("response", response)

                const xAxisColumnValue = response.map(xaxis => xaxis[selectedCombinedBoxWhiskerColumnsValue]);
                console.log("xAxisColumnValue:", xAxisColumnValue);
                setXaxis(xAxisColumnValue);
                const yAxisColumnValue = response.map(xaxis => xaxis[rightListBoxWhiskerValue]);
                console.log("yAxisColumnValue:", yAxisColumnValue);

                // const datasets1 = prepareDataset(data, xAxisColumnValue, rightListBoxWhiskerValue);
                // setDataSets(datasets1);


                //  const datasets1 = yAxisColumnValue.map((column,index) => {
                //     return {
                //         label: xAxisColumnValue[index],
                //         y: yAxisColumnValue[index],
                //         backgroundColor: generateRandomColor(), // You can define or generate colors here
                //     };
                // });
                // console.log("Datasets:", datasets1);
                // setDataSets(datasets1);
                // const datasets1 = yAxisColumnValue.map((yValue, index) => {
                //     return {
                //      //   type: "boxAndWhisker",
                //      //   label: xAxisColumnValue[index],
                //         dataPoints: [{ label: xAxisColumnValue[index], y: [yValue] }],
                //      //   backgroundColor: generateRandomColor(),
                //     };
                // });
                /* TO CHECK */
                // const datasets = response.map((column, index) => {
                //     return {
                //       label: xAxisColumnValue[index],
                //       y: column[rightListBoxWhiskerValue],
          
                //       //  backgroundColor: generateRandomColor(), // You can define or generate colors here
                //     };
                //   });
                //  console.log(JSON.stringify(datasets)+"datasets");
                const dataPoints = response.map((label, index) => ({
                    label: xAxisColumnValue[index],
                    y: yAxisColumnValue.slice(0, 5),
                    color: generateRandomColor(),
                }));
                console.log(JSON.stringify(dataPoints) + "dataPoints--");
                setDataSets(dataPoints);

                console.log(JSON.stringify(dataSets) + "dataSets**");


            }).then((res) => {
                console.log("res", res)
            }).
                catch(e => {
                    console.log("error", e)
                })
        }
        fetchData();
    },

        [selectedCombinedBoxWhiskerColumnsValue, verticalBoxWhiskerLabelValue, horizantalBoxWhiskerLabelValue, rightListBoxWhiskerValue])


    console.log(JSON.stringify(dataSets) + "OUT");
    const dataPoints = [
        { label: "Bread", y: [179, 256, 300, 418, 274] },
        { label: "Cake", y: [252, 346, 409, 437, 374.5]},
        { label: "Biscuit", y: [236, 281.5, 336.5, 428, 313] },
        { label: "Doughnut", y: [340, 382, 430, 452, 417] },
        { label: "Pancakes", y: [194, 224.5, 342, 384, 251] },
        { label: "Bagels", y: [241, 255, 276.5, 294, 274.5] }
    ]

    const options = {
        theme: "light2",
        animationEnabled: true,
        title: {
            text: "Employee Salary Details"
        },
        axisY: {
            title: "Salary calculation based on the Department"
        },
        data: [
            {
                type: "boxAndWhisker",
                yValueFormatString: "#,##0.# \"kcal/100g\"",
              //  dataPoints: dataSets
                dataPoints:[
                    { label: "Bread", y: [179, 256, 300, 418, 274] },
                    { label: "Cake", y: [252, 346, 409, 437, 374.5]},
                    { label: "Biscuit", y: [236, 281.5, 336.5, 428, 313] },
                    { label: "Doughnut", y: [340, 382, 430, 452, 417], x: 5 },
                    { label: "Pancakes", y: [194, 224.5, 342, 384, 251] },
                    { label: "Bagels", y: [241, 255, 276.5, 294, 274.5] }
                ]
            }
        ]

    };


    return (
        <div>
            <CanvasJSChart data={data} options={options} />
        </div>
    );
};

export default BoxWhiskerChart;
